// extracted by mini-css-extract-plugin
export default {"wrapper":"ADSKeepStructure_wrapper__us-zW","disabled":"ADSKeepStructure_disabled__7e6GR"};